import { render, staticRenderFns } from "./chaldalFaq.vue?vue&type=template&id=1bc75f24&"
import script from "./chaldalFaq.vue?vue&type=script&lang=js&"
export * from "./chaldalFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports